import React from 'react';

export const OnboardingHeadConstants: Array<{
  id: number;
  title: React.ReactNode;
  description?: React.ReactNode;
}> = [
  {
    id: 0,
    title: <>A Few Quick Questions ✍️</>,
    description: (
      <>Answer a couple of quick questions so we can set things up right for your team.</>
    ),
  },
  {
    id: 1,
    title: <>Name Your AI Agent 🪪</>,
    description: (
      <>
        Give your AI agent a name. This is the name customers will see when your AI
        <br /> Agent responds. For example: “Support Bot” or “Sales Assistant.”
      </>
    ),
  },
  {
    id: 2,
    title: <>Train Your AI Agent 📚</>,
    description: (
      <>
        Your AI can only answer questions if it knows the answers!
        <br /> Here’s how to feed it info:
      </>
    ),
  },
  {
    id: 3,
    title: <>Choose how you’d like to set up the system prompt for your AI Agent🤖</>,
  },
  {
    id: 4,
    title: <>Choose Your AI Agent’s Role 💼</>,
    description: <>Assign your AI a primary role.</>,
  },
  {
    id: 5,
    title: <>Give Your AI Voice 📣</>,
    description: <>Decide how your AI Agent should sound in conversations.</>,
  },
  {
    id: 6,
    title: <>Set Escalation Workflow 🔀</>,
    description: <>Decide how your AI should handle unanswered questions.</>,
  },
];

export const OnboardingHeadConstantsManualSystemPompt = {
  id: 4,
  title: <>write the system prompt 💻</>,
  description: (
    <>
      Enter the instructions that will guide your AI Agent’s behavior, tone, and responses. You can
      start by selecting a template below.
    </>
  ),
};
